
export default {
  props: {
    testimonials: {
      type: Array,
      default: () => [
        {
          img: require("~/assets/img/testimonials/testi-y-toitures.png"),
          tags: [0],
          text: "Je suis très content de leurs services. Toujours à l’écoute et prêts à nous aider. Je recommande pour tout développement dans le domaine internet. Merci à toute l’équipe.",
          author: "Yves HUMMEL — Y Toitures",
        },
        {
          img: require("~/assets/img/testimonials/testi-atc-home.jpg"),
          tags: [0, 2],
          text: "Merci à toute l’équipe pour votre réactivité et votre professionnalisme. Merci à Jamel pour son écoute et son accompagnement au sein de nos projets.",
          author: "Adrien ADAM - ATC Home",
        },
        {
          img: require("~/assets/img/testimonials/testi-gt-autos.jpg"),
          tags: [3, 0, 2],
          text: "Cela fait 3 ans que notre société travaille avec ALEO et ils sont toujours aussi sympathiques et professionnels. Nous leur avons confié ce jour notre site internet ainsi que nos cartes de visite et je suis sûre du résultat, il sera parfait.",
          author: "Cindy TABTI - GT AUTOS MOTORCRAFT",
        },
        {
          img: require("~/assets/img/testimonials/testi-auto-ecole-notre-dame.jpg"),
          tags: [1, 2],
          text: "Je suis très satisfait de ma collaboration avec cette agence : les visuels sont d'une grande qualité et la graphiste en charge de mon dossier est à l'écoute et réactive.",
          author: "Stéphane CRETIN - Auto école Notre Dame",
        },
      ],
    },
    buttonVisible: {
      type: Boolean,
      default: true,
    },
    surtitle: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Des solutions adaptées à tous les corps de métier",
    },
    text: {
      type: String,
      default:
        "Prenez part au voyage qui changera le cours de votre activité !",
    },
  },
  data() {
    return {
      tagsList: [
        {
          tag: "Site web & référencement",
          color: "text-accent-700",
          bg: "bg-accent-100",
          link: "web",
        },
        {
          tag: "Publicité sur Google",
          color: "text-warning-700",
          bg: "bg-warning-100",
          link: "seo",
        },
        {
          tag: "Réseaux sociaux",
          color: "text-primary-700",
          bg: "bg-primary-50",
          link: "gestion-rs",
        },
        {
          tag: "Graphisme & identité",
          color: "text-success-700",
          bg: "bg-success-100",
          link: "graphism",
        },
      ],
      glideInit: "",
    };
  },

  methods: {
    initGlide() {
      import("@glidejs/glide/dist/css/glide.core.min.css");
      const getGlide = () => import("@glidejs/glide/dist/glide.modular.esm");
      getGlide().then(({ default: Glide, Controls, Swipe, Breakpoints }) => {
        this.glideInit = new Glide("#glide-testimonial", {
          type: "carousel",
          perView: 1,
          gap: 25,
          breakpoints: {
            640: {
              perView: 1,
            },
            768: {
              perView: 1.2,
              gap: 45,
            },
            1024: {
              perView: 1,
            },
          },
        }).mount({ Controls, Swipe, Breakpoints });
      });
    },

    viewHandler(e) {
      if (e.type === "enter") {
        this.initGlide();
      }
    },
  },
};
